<template>
  <div class="container">
    <p class="top-p">A window of opportunity has opened.</p>
    <p class="top-p">
      We stand at the threshold of creating superintelligent systems.
    </p>
    <p class="top-p">
      We still retain some agency over how control over these systems will be
      distributed. Will it be by a select few only, or by the people of the
      planet at large?
    </p>
    <p class="top-p">This is the most important question of our age.</p>
    <p class="top-p">~</p>

    <div class="row regular-row">
      <div class="col-6">
        <p class="block-text">
          Imagine a world where only a select few control superintelligent
          systems.
        </p>
      </div>
      <div class="col-6">
        <p class="block-text">
          <b>Compute is abundant, but it is fragmented.</b>
        </p>
      </div>
      <div class="col-6">
        <p class="block-text">
          This high priesthood can bend reality to their will. They gate-keep
          technological and scientific innovation.
        </p>
      </div>
      <div class="col-6">
        <p class="block-text">
          Compute is not a scarce resource, but connecting it and using it in
          unison without owning all of it is hard. Thus, it sits idle and
          underutilized.
        </p>
      </div>
      <div class="col-6">
        <p class="block-text">
          As long as building these systems remains prohibitively expensive,
          this is a real possibility.
        </p>
      </div>
      <div class="col-6">
        <p class="block-text">
          We tap into this idle compute and make it possible for every GPU on
          the planet to join the Mercury Compute Network.
        </p>
      </div>

      <div class="col-6">
        <p class="block-text">
          Superintelligence can only be aligned with humanity's interests if all
          of humanity gets a chance to contribute to it.
        </p>
      </div>
      <div class="col-6">
        <p class="block-text">
          Our mission is to align and accelerate AI development by connecting
          compute and lowering its price.
        </p>
      </div>
      <p>~</p>
    </div>

    <div class="row mobile-row">
      <div class="col-12">
        <p class="block-text">
          Imagine a world where only a select few have superintelligent AI.
        </p>
      </div>
      <div class="col-12">
        <p class="block-text">
          This high priesthood can bend reality to their will. They gate-keep
          technological and scientific innovation.
        </p>
      </div>
      <div class="col-12">
        <p class="block-text">
          As long as building these systems remains prohibitively expensive,
          this is a real possibility.
        </p>
      </div>
      <div class="col-12">
        <p class="block-text">
          Superintelligence can only be aligned with humanity's interests if all
          of humanity gets a chance to contribute to it.
        </p>
      </div>
      <p>~</p>
      <div class="col-12">
        <p class="block-text">
          <b>Compute is abundant, but it is fragmented.</b>
        </p>
      </div>
      <div class="col-12">
        <p class="block-text">
          Compute is not a scarce resource, but connecting it and using it in
          unison without owning it is hard. Thus, it sits idle and
          underutilized.
        </p>
      </div>
      <div class="col-12">
        <p class="block-text">
          We tap into this idle compute and make it possible for every GPU to
          join the Mercury Compute Network.
        </p>
      </div>
      <div class="col-12">
        <p class="block-text">
          Our mission is to align and accelerate AI development by connecting
          compute and lowering its price.
        </p>
      </div>
      <p>~</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextMiddle",
};
</script>

<style scoped>
p {
  color: var(--text-primary-color);
  font-family: "Anonymous Pro", monospace;
  font-size: 20px;
  text-align: center;
}
.container {
  margin-top: 150px;
}
.block-text {
  text-align: left;
}
.top-p {
  margin-top: 50px;
  margin-bottom: 50px;
}
.col-6 {
  margin-bottom: 20px;
}

.mobile-row {
  display: none;
}

/* extra small & small */
@media screen and (max-width: 767px) {
  p {
    font-size: 15px;
  }
  .container {
    margin-top: 100px;
  }
  .regular-row {
    display: none;
  }

  .block-text {
    text-align: center;
  }
  .mobile-row {
    display: initial;
  }
  .top-p {
    margin-top: 30px;
    margin-bottom: 0;
  }
}
</style>